import {
  Box,
  Button,
  ColumnConfig,
  DataTable,
  Form,
  FormField,
  Layer,
  Text,
  TextInput,
  Select,
  CheckBox,
  Grommet
} from "grommet";
import { Observer, observer } from "mobx-react";
import React, { useEffect, useMemo, useState } from "react";
import { useStore } from "../../../../../Hooks/useStore";
import { toJS } from "mobx";
import { Mixpanel } from "../../../../../util/Helper";
import DisableSidebar from "../../../../../assets/close_small.svg";
import { userStore } from "../../../../../store/UserStore";
import usersService from "../../screens/IAM/Users/users.service";
import "./EditProfileUsers.css";
import { setUser } from "@sentry/react";
import { UserType } from "../../screens/IAM/Users/types/UserType";
import createuserService from "../../screens/IAM/Users/CreateUser/createuser.service";
import { useLocation } from "react-router-dom";

// interface EditProfileProps {
//   user: UserType;
// }



function EditProfileUsers() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const username = searchParams.get("username");
  const { rootStore } = useStore();

  const [inputValue, setInputValue] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [checked,setChecked] = useState(false);
  const visibleUsersList = rootStore?.adminStore?.getUsers;

  // Only compute `userEnabled` once `visibleUsersList` is available
  const userEnabled = useMemo(() => {
    if (visibleUsersList && visibleUsersList.length > 0) {
      const user = visibleUsersList.find(item => item.username === rootStore.adminStore.getUsername);
      return user?.enabled || false;
    }
    return false;
  }, [rootStore.adminStore.getUsername, visibleUsersList]);

  // Ensure `useEffect` only runs after `userEnabled` is computed
  useEffect(() => {
    if (visibleUsersList && checked !== userEnabled) {
      setChecked(userEnabled);
    }
  }, [userEnabled, visibleUsersList]);

  // Custom Grommet theme for checkbox background (track) color
  const customTheme = {
    checkBox: {
      toggle: {
        extend: (props: { checked: boolean }) =>
          `background-color: ${checked ? 'rgb(53, 126, 255)' : 'lightgray'}; 
        border-color: rgb(53, 126, 255)
      `,
        knob: {
          extend: `
          background-color: white !important;
          border: 1px solid rgb(53, 126, 255);
        `,
        },

      },
    },
  };

  // const handleInputChange = (event) => {
  //   setInputValue(event.target.value);
  // };
  // const handleSubmit = () => {

  //   console.log('Form submitted with value:', inputValue);

  // };

  useEffect(() => {
    (async () => {
      // console.log(rootStore.adminStore,"from herererere")
      let organizations = await createuserService.getOrganizations();

      rootStore.adminStore.handleCreateFlightOrgList(organizations);
    })();
  }, []);
  // const { rootStore } = useStore();
  //  const handleUserShowDisableConfirmation = () => {
  //    this.userShowDisableConfirmation = newVal;
  //  }
  //  const onSubmit = async () => {
  //      //console.log("tttt",profile);
  //      await usersService.updateUserByAdmin(rootStore.editProfileStore.getProfile);
  //      rootStore.notificationToastStore.showNotification("Profile Update Successfully.",false, 3000);
  //    }


  let userInfo;
  useEffect(() => {
    (async () => {
      userInfo = localStorage.getItem("userinfo");
      if (userInfo) {
        let roleLabel = JSON.parse(userInfo).roleLabel;
        let email = JSON.parse(userInfo).email;
        rootStore.adminStore.handleRoleLabel(roleLabel);
        rootStore.adminStore.handleUserEmail(email);
        if (roleLabel.toLowerCase() == "admin") {
          let username = JSON.parse(userInfo).username;
          let userOrg = await createuserService.getOrgByUserName(username);
          // rootStore.adminStore.handleAddOrg(userOrg.id)
          rootStore.adminStore.handleSelectedOrgId(userOrg.id);
        }
      }
    })();
  }, [userInfo]);


  const handleGenderChange = (event: any) => {
    rootStore.editProfileStore.setProfile({
      gender: event.target.value,
    });
  };

  const GENDER_OPTIONS = [
    // { label: "Select", value: "Select" },
    {
      label: "Male",
      value: "male",
    },
    {
      label: "Female",
      value: "female",
    },
    {
      label: "Others",
      value: "others",
    },
  ];

  const roleName = rootStore.adminStore.getRoleName;
  const userEmail = rootStore.adminStore.getUserEmail.split("@");
  let last = userEmail[userEmail.length - 1];
  const isSuperAdmin = rootStore.adminStore.getCustomType === "superAdmin";

  const CUSTOM_TYPE_OPTIONS = [
    { label: "Admin", value: "admin" },
    { label: "Crew", value: "crew" },
    ...(roleName.toLowerCase() !== "admin"
      ? [
        ...(isSuperAdmin
          ? [
            {
              label: "SuperAdmin",
              value: "superAdmin",
            },
          ]
          : []),
        {
          label: "EMS",
          value: "ems",
        },
      ]
      : []),
    ...(roleName.toLowerCase() == "admin" && `@${last}` == "@vituity.com"
      ? [
        {
          label: "EMS",
          value: "ems",
        },
      ]
      : []),
  ];

  const [user, setUser] = useState({
    "custom:type": "Select",
    gender: "Select",
  } as UserType);

  //  alert(rootStore.adminStore.getUsername);

  interface User {
    userName: string;
    email: string;
  }

  const resendMail = (user:User) => {
    // const {rootStore} = useStore();
    // const [isEditFormOpen, setIsEditFormOpen] = useState(false);


    return(
      <div className="cell-container">
        <Button

                  style={{  display: "flex",
            padding: "7px 12px",
            alignItems: "center",
            gap: "10px",
            borderRadius: "6px",
            border: "1px solid #357EFF",
            background: "#FFF",
            color: "#357EFF",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: "600",
                    lineHeight: "14px" /* 116.667% */}}
          primary
          color={"brand-1"}
          label="Resend Invite"
                    onClick={()=> resendEmail(user)}
        />
      </div>
    )
  }


  const resendEmail = async (user: User) => {
    if (user) {
      try {
        let result = await usersService.resendMail(user.userName, user.email);
        if (result == "Email Sent") {
          rootStore.notificationToastStore.showNotification("Email send successfully.", false, 3000);
        } else if (result == "error") {
          rootStore.notificationToastStore.showNotification("There was an error while attempting to send the email.", true, 3000);
        } else { }
      } catch (error) {
        console.log('error in resend mail', error);
      }
    }
  }

  const getUserByUserName = async (uname: String) => {
    let user = await usersService.listUsersByUsername(uname.toString());
    const isApprovedSuperAdmin = user[0]["custom:isApprovedSuperAdmin"];
    let username = user[0].username ?? "";
    let fieldconfirm = "false";
    let userRoles = await usersService.getUserRoles(username);
    if (userRoles.length) {
      userRoles.map((role: any) => {
        if (role.code == "SuperAdmin") {
          fieldconfirm = "true";
        }
      });
    }
    rootStore.editProfileStore.setProfile({
      username: user[0].username ?? "",
      email: user[0].email ?? "",
      name: user[0].name ?? "",
      familyName: user[0].family_name ?? "",
      customType: user[0]["custom:type"] ?? "",
      phoneNumber: "2346234",
      gender: user[0].gender ?? "",
      showfield: fieldconfirm,
      isApproved: isApprovedSuperAdmin,
    });
  };

  
  const onSubmit = async () => {
    // alert("hii")
    // const { isApproved, showfield, ...profileupdate } = rootStore.editProfileStore.getProfile;
    // if (username && rootStore.editProfileStore.getInitialOrg !== rootStore.editProfileStore.getSelectedOrg) {
    //   createuserService.updateConfirmStatus(username, rootStore.editProfileStore.getSelectedOrg.toString())
    // }
    // await usersService.updateUserByAdmin(profileupdate);
    // alert(JSON.stringify(profileupdate))
    // if (user) {
    //   if (rootStore.editProfileStore.getProfile.showfield === "true" && user.email == "huseinattarwala@skalillc.com") {
    //     await usersService.updateConfirmStatus(rootStore.editProfileStore.getProfile.isApproved, rootStore.editProfileStore.getProfile.username);
    //   }
    // }
    // rootStore.notificationToastStore.showNotification("Profile Update Successfully.",false, 3000);
  };

  // const onSubmit = async () => {
  //   const { isApproved, showfield, ...profileupdate } = rootStore.editProfileStore.getProfile;
  //   if (username && rootStore.editProfileStore.getInitialOrg !== rootStore.editProfileStore.getSelectedOrg) {
  //     createuserService.updateConfirmStatus(username, rootStore.editProfileStore.getSelectedOrg.toString())
  //   }
  //   await usersService.updateUserByAdmin(profileupdate);
  //   if (user) {
  //     if (rootStore.editProfileStore.getProfile.showfield === "true" && user.email == "huseinattarwala@skalillc.com") {
  //       await usersService.updateConfirmStatus(rootStore.editProfileStore.getProfile.isApproved, rootStore.editProfileStore.getProfile.username);
  //     }
  //   }
  //   rootStore.notificationToastStore.showNotification("Profile Update Successfully.",false, 3000);
  // }

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    try {
      await usersService.updateUserByAdmin({
        username: rootStore.adminStore.getUsername,
        email: rootStore.adminStore.getEmail,
        name: rootStore.adminStore.getFirstName,
        familyName: rootStore.adminStore.getFamilyName,
        customType: rootStore.adminStore.getCustomType,
        gender: rootStore.adminStore.getGender,
      });

      rootStore.notificationToastStore.showNotification(
        "User updated successfully",
        false,
        3000
      );
      rootStore.adminStore.handleupdate();
      rootStore.adminStore.handleEditProfileUser(false);


    } catch (error) {
      console.error("Error handling user:", error);
      rootStore.notificationToastStore.showNotification(
        "Failed to update user. Please try again later.",
        true,
        3000
      );
    }
  };
  const reset = () => {
    try {
      // Fetch user data by username
      usersService.listUsersByUsername(rootStore.adminStore.getEditProfileUsername).then((userResponse) => {
        if (userResponse.length > 0) {

          rootStore.adminStore.handleUserName(userResponse[0]?.username ?? "");
          rootStore.adminStore.handleEmail(userResponse[0]?.email ?? "");
          rootStore.adminStore.handleFirstName(userResponse[0]?.name ?? "");
          rootStore.adminStore.handleFamilyname(userResponse[0]?.family_name ?? "");
          rootStore.adminStore.handleCustomType(userResponse[0]?.["custom:type"] ?? "");
          rootStore.adminStore.handleGender(userResponse[0]?.gender ?? "");
          // setIsEditFormOpen(true); // Open the edit form

          // Fetch additional data using createuserService.getOrgByUserName
          createuserService.getOrgByUserName(rootStore.adminStore.getEditProfileUsername).then((orgResponse) => {
            //alert(JSON.stringify(orgResponse))
            // Assuming orgResponse contains organization data
            rootStore.adminStore.handleOrganization(orgResponse.id);

            // Optionally handle other properties from orgResponse if needed
          }).catch((orgError) => {
            console.error("Error fetching organization data:", orgError);
          });
        } else {
          console.log("No user found with username:", rootStore.adminStore.getEditProfileUsername);
        }
      });
    } catch (error) {
      console.log("Error fetching user data:", error);
    }
  };

  const userName = rootStore.adminStore.getUsername;
  const email = rootStore.adminStore.getEmail;
  const getUserStatus = rootStore.adminStore.getUserStatus;

  return (
    <Layer
      className="disable-user-sidebar-container"
      style={{
        borderRadius: "12px 0px 0px 0px",
        width: "500px",
        height: "100%",
      }}
      onClickOutside={() => {
        rootStore.adminStore.handleEditProfileUser(false);
        rootStore.adminStore.handleSelectedUser([])
      }}
      onEsc={() => {
        rootStore.adminStore.handleEditProfileUser(false);
        rootStore.adminStore.handleSelectedUser([])
      }}
      full="vertical"
      position="right"
    // onEsc={() => {
    //     Mixpanel.track("web close " + submitButtonTitle);
    //     onCancel();
    // }}
    >
      <Box
        fill
        style={{
          minWidth: "378px",
          borderRadius: "12px 0px 0px 0px",
          maxWidth: "500px",
        }}
        flex
        flex-start
        direction="column"
        align="center"
      >
        <Box
          style={{
            borderRadius: "12px 0px 0px 0px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          direction="column"
          as="header"
          background={"#E9F2FF"}
          width="100%"
          pad={"small"}
        >
          <Text
            style={{
              color: "#4B628A",
              fontFamily: "Inter",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "20px",
            }}
          >
            Edit Profile
          </Text>
          <Button
            className="close-btn"
            style={{
              color: "#357EFF",
              fontFamily: "Inter",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "16px",
            }}
            onClick={() => {
              rootStore.adminStore.handleEditProfileUser(false);
              rootStore.adminStore.handleSelectedUser([])
            }}
          >
            <img src={DisableSidebar} style={{ width: 20, height: 20 }} />
            Close
          </Button>
        </Box>
        <Form
          style={{ overflow: "scroll" }}
          validate="change"
          onSubmit={handleSubmit}
          className="edit-profile-modal-form"
        >
          {getUserStatus !== "CONFIRMED" && (
            <div style={{
              display:'flex',
              justifyContent:'space-between'
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            >
            <span style={{fontSize:'12px'}}></span>
            {resendMail({userName,email})}
            </div>
          )}
          {isHovered && (
            <div style={{
              fontSize: '12.5px',
              color: '#666',
              lineHeight: '1.4',
              padding: '10px'
            }}>
              This feature allows administrators to resend the onboarding invitation email to users who have not yet configured their account credentials or may have misplaced the original invitation. The email includes their username and a temporary password to facilitate account setup. Please note that invitations cannot be resent to users who have already set their password.
            </div>
          )}
          <FormField
            className="edit-profile-modal-form-F1"
            name="username"
            htmlFor="textinput-id"
          >
            <label className="edit-profile-modal-form-L1">Username</label>
            <TextInput
              className="edit-profile-modal-form-I1"
              placeholder="Username"
              id="textinput-id"
              name="username"
              value={rootStore.adminStore.getUsername}
              onChange={(e) => {
                rootStore.adminStore.handleUserName(e.target.value);
              }}
              readOnly={true}
            />
          </FormField>
          <FormField
            className="edit-profile-modal-form-F2"
            name="email"
            htmlFor="textinput-id"
            required
            validate={[
              {
                regexp:
                  /^[a-zA-Z0-9][a-zA-Z0-9._-]*[a-zA-Z0-9]@[a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/,
                  // /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: "Invalid email format.",
              },
            ]}
          >
            <label className="edit-profile-modal-form-L1">Email</label>
            <TextInput
              className="edit-profile-modal-form-I2"
              id="textinput-id"
              name="email"
              type={"email"}
              placeholder="Email"
              maxLength={50}
              value={rootStore.adminStore.getEmail}
              onChange={(event) => {
                const lowercaseEmail = event.target.value.toLowerCase();
                event.target.value = lowercaseEmail;
                rootStore.adminStore.handleEmail(event.target.value);
              }}
            />
          </FormField>
          <Box className="edit-profile-modalboxform">
            <FormField
              className="edit-profile-modal-form-F3"
              name="name"
              htmlFor="textinput-id"
              validate={[
                {
                  regexp: /^[A-Za-z]+$/,
                  message: "First Name should contain only alphabets.",
                },
              ]}
              required
            >
              <label className="edit-profile-modal-form-L1">First Name</label>
              <TextInput
                className="edit-profile-modal-form-I3"
                id="textinput-id"
                name="name"
                placeholder="First Name"
                maxLength={40}
                value={rootStore.adminStore.getFirstName}
                onChange={(e) => {
                  rootStore.adminStore.handleFirstName(e.target.value);
                }}
              />
            </FormField>
            <FormField
              className="edit-profile-modal-form-F4"
              name="family_name"
              htmlFor="textinput-id"
              validate={[
                {
                  regexp: /^[A-Za-z]+$/,
                  message: "Last Name should contain only alphabets.",
                },
              ]}
              required
            >
              <label className="edit-profile-modal-form-L1">Last Name</label>
              <TextInput
                className="edit-profile-modal-form-I4"
                id="textinput-id"
                name="family_name"
                placeholder="Last Name"
                maxLength={40}
                value={rootStore.adminStore.getFamilyName}
                onChange={(e) => {
                  rootStore.adminStore.handleFamilyname(e.target.value);
                }}
              />
            </FormField>
          </Box>
          <FormField
            className="edit-profile-modal-form-F6"
            name="gender"
            htmlFor="textinput-id"
            required
          >
            <label className="edit-profile-modal-form-L1">Gender</label>
            <div className="edit-profile-modal-form-S1">
              <Select
                className="edit-profile-modal-form-S1"
                name="gender"
                labelKey={"label"}
                valueKey={{ key: "value", reduce: true }}
                options={GENDER_OPTIONS}
                // defaultValue={"Select"}
                value={rootStore.adminStore.getGender}
                onChange={(e) => {
                  rootStore.adminStore.handleGender(e.target.value);
                }}
              />
            </div>
          </FormField>

          {/* <FormField
           className="edit-profile-modal-form-F5"
             name="gender"
             htmlFor="textinput-id"
             required
           >
             <label className="edit-profile-modal-form-L1">
               Gender
             </label>
             <div className="edit-profile-modal-form-S1">
             <Select
             
            
               name="gender"
              //  labelKey={"label"}
              //  valueKey={{ key: "value", reduce: true }}
               options={GENDER_OPTIONS}
               defaultValue={"Select"}

               value={rootStore.adminStore.getGender}
              onChange={(e) =>{rootStore.adminStore.handleGender(e.target.value)}}
             />
             </div>
             </FormField> */}

          <FormField
            className="edit-profile-modal-form-F6"
            name="profile"
            htmlFor="textinput-id"
            required
          >
            <label className="edit-profile-modal-form-L1">Profile</label>
            <div className="edit-profile-modal-form-S1">
              <Select
                className="edit-profile-modal-form-S1"
                name="profile"
                labelKey={"label"}
                valueKey={{ key: "value", reduce: true }}
                options={CUSTOM_TYPE_OPTIONS}
                value={rootStore.adminStore.getCustomType}
                defaultValue={"crew"} 
                disabled={isSuperAdmin}  
                onChange={(e) => {
                  rootStore.adminStore.handleCustomType(e.target.value);
                }}
              /> 

            </div>
          </FormField>
          {/* {user?.["custom:type"] === "coordinator" && (
            <FormField name="phoneNumber" htmlFor="textinput-id" required>
              <TextInput
                id="textinput-id"
                name="phoneNumber"
                placeholder="Phone number"
              />
            </FormField>
          )} */}

          {rootStore.adminStore.getOrganization && (
            <FormField
              className="edit-profile-modal-form-F6"
              label="Organization"
              name="organization"
              htmlFor="textinput-id"
              required
            >
              <div
                className={
                  rootStore.adminStore.getRoleName.toLowerCase() == "admin"
                    ? "create-user-org-outer"
                    : "sbxadmin"
                }
              >
                <Select
                  name="organization"
                  labelKey={"label"}
                  valueKey={{ key: "value", reduce: true }}
                  options={rootStore.adminStore.getCreateFlightOrgList.map(
                    (org) => {
                      return {
                        label: org.name,
                        value: org.id,
                      };
                    }
                  )}
                  value={rootStore.adminStore.getOrganization}
                  defaultValue={""}
                  onChange={(event) => {
                    rootStore.adminStore.handleEdit(event.option.value);
                  }}
                />
              </div>
            </FormField>
          )}

          <Grommet theme={customTheme}>
            <Box direction="row" align="center" pad="medium" gap="small" >
              {/* Label on the left */}
              <Text style={{
                color: "#4B628A",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
              }}>
                {checked ? 'User Enabled' : 'User Disabled'}
              </Text>
              <CheckBox
                toggle
                checked={checked}
                disabled={checked ? false : true}
                onChange={(event) => {
                  Mixpanel.track("web_disable_user_click", { name: user?.username });
                  rootStore.adminStore.handleUserShowDisableConfirmation(true);
                  // rootStore.adminStore.setUsersActionMenu();
                  // setChecked(event.target.checked)
                }
                }
              />
            </Box>
          </Grommet>

          <Box
            className="disable-user-btn"
            style={{ marginLeft: "auto" }}
            as="footer"
            // border={{ side: "top" }}
            pad="small"
            justify="end"
            direction="row"
            align="center"
          >
            <Button
              style={{
                color: "#357EFF",
                display: "flex",
                width: "120px",
                padding: "14px 49px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderRadius: "10px",
                border: "1px solid #357EFF",
                background: "#FFF",
              }}
              onClick={() => {
                Mixpanel.track("web_disable_user_cancel_click", { name: user?.username });
                reset();
                // rootStore.adminStore.handleEmail("");
                // rootStore.adminStore.handleFirstName("");
                // rootStore.adminStore.handleFamilyname("");
                // rootStore.adminStore.handleGender("");
                // rootStore.adminStore.handleCustomType("");
              }}
              label="Reset"
            />
            <Button
              label="Save"
              style={{
                display: "flex",
                width: "120px",
                padding: "14px 49px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                borderRadius: "10px",
                background: "#357EFF",
                color: "var(--all-colors-white-color-white, #FFF)",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "24px",
              }}
              type="submit"

            //   className={`myButton ${inputValue === 'DISABLE' ? 'active' : 'disabled'}`}
            //  onClick={onSubmit}
            />
          </Box>
        </Form>
      </Box>
    </Layer>
  );
}
export default observer(EditProfileUsers);
